<template>
  <div>
    <div class="title-cont">
      <h2>Anfragen</h2>
    </div>
    <div id="logs" class="logs-container">
      <div>
        <DataTable
          :value="allLogs"
          :paginator="true"
          class="p-datatable-products"
          :rows="10"
          :filters="filters"
          data-key="id"
          :loading="loading"
        >
          <template #header>
            <div class="table-header">
              <span class="p-input-icon-left">
                <i class="pi pi-search" />
                <input class="p-inputtext p-component" type="text"
                       v-model="filters['global']" placeholder="Suchen" />
              </span>
            </div>
          </template>
          <template #empty>Keine Modelle gefunden.</template>
          <template #loading>Lade alle Modelle...</template>
          <Column field="merchantId" header="Händler-ID" sortable>
            <template #body="slotProps">{{
              slotProps.data.merchantId
            }}</template>
          </Column>
          <Column field="supplierId" header="Lieferanten-ID" sortable>
            <template #body="slotProps">{{
              slotProps.data.supplierId
            }}</template>
          </Column>
          <Column field="products" header="Anfrage">
            <template #body="slotProps">
              <div>
                <template
                  v-for="(product, index) in JSON.parse(
                    slotProps.data.products
                  )"
                >
                  <div :key="product._id" v-if="index === 0">
                    <p>
                      Product ID:{{ product.productId }}
                      <br />
                      Product:{{ product.pname }}
                    </p>
                    No. of items:
                    {{ JSON.parse(slotProps.data.products).length }}
                  </div>
                </template>
              </div>

              <a
                v-if="JSON.parse(slotProps.data.products).length > 1"
                href="#"
                @click="viewResponse(JSON.parse(slotProps.data.products))"
                >View all</a
              >
            </template>
          </Column>
          <Column field="dateAccessed" header="Zeitpunkt" sortable>
            <template #body="slotProps">
              {{ slotProps.data.dateAccessed }}
            </template>
          </Column>
        </DataTable>
      </div>

      <Dialog
        header="Response"
        :visible.sync="displayResponseModal"
        :style="{ width: '50vw' }"
      >
        <div class="p-fluid">
          <template v-for="product in selectedResponse">
            <div :key="product._id">
              <p>
                Modell-ID: {{ product.productId }}
                <br />
                Modell: {{ product.pname }}
              </p>
            </div>
          </template>
        </div>

        <template #footer>
          <Button
            label="Schließen"
            icon="pi pi-times-circle"
            @click="displayResponseModal = false"
            autofocus
          />
        </template>
      </Dialog>
    </div>
  </div>
</template>

<script>
import { FETCH_PRODUCTS } from "../../../store/actions.type"
import DataTable from "primevue/datatable"
import Column from "primevue/column"
import Dialog from "../../../components/Dialog"
import { RequestLogsService } from "../../../http/services/request-logs"
import ProgressSpinner from "primevue/progressspinner"
import axios from "axios"

export default {
  name: "Products",
  data() {
    return {
      suppliers: [],
      allLogs: [],
      loading: true,
      filters: {},
      displayResponseModal: false,
      selectedResponse: []
    }
  },
  mounted() {
    if (!this.isAdmin()) this.$router.push("/suppliers")

    this.fetchRequestLogs()
  },
  methods: {
    viewResponse(response) {
      this.selectedResponse = response
      this.displayResponseModal = true
    },
    fetchRequestLogs() {
      let self = this

      RequestLogsService.getAll()
        .then(function (response) {
          self.allLogs = response.data
          console.log(self.allLogs)
          self.loading = false
        })
        .catch(error => console.log(error))
      // axios.get('/api/get-request-logs')
      //   .then(function (response) {
      //     self.allLogs = response.data
      //     console.log(self.allLogs)
      //   }).catch((error) => console.log(error))
    }
  },
  created() {
    if (!this.$msal.isAuthenticated()) {
      this.$router.push("/login")
    }

    if (this.$msal.isAuthenticated()) {
    }
  },
  computed: {},
  watch: {
    allSuppliers(suppliers) { }
  },
  components: {
    DataTable,
    Column,
    Dialog,
    ProgressSpinner
  }
};
</script>

<style lang="scss">
.logs-container {
  .p-button{
    background: #293642;
    border: 1px solid #293642;
  }

  .p-datatable .p-sortable-column.p-highlight {
    background: #969696;
    color: #ffffff;
  }
}
.title-cont {
  padding: 2em;

  h2 {
    color: #2a3642;
  }
}

</style>



// WEBPACK FOOTER //
// src/view/pages/admin/Logs.vue